module.exports = __webpack_public_path__ + "img/clear-score-logo.2b210a01.png";